/*
  account（账号管理）by张帅 2020/2/20
  添加gl xj 两工厂的扫码绑定
*/
<template>
  <div class="account mainWrap" v-loading.fullscreen.lock="fullscreenLoading">
    <el-container style="height:100%; background-color:rgba(0, 0, 0, 0);">
      <!-- 左边导航栏 -->
      <el-aside style="width:auto;">
        <leftNav msg="/account"></leftNav>
      </el-aside>
      <!-- 右侧主体部分 -->
      <el-scrollbar class="machineWrap" style="height:100%;width:100%;">
        <el-main>
          <div class="mainWrao">
            <div class="recordTitle">
              <h1>{{$t('leftNav.nav23')}}</h1>
            </div>
            <div class="tableWrap" >
              <!-- 上半部分个人信息 -->
              <el-container>
                <el-aside width="200px" class="accountLeft"><p>{{$t('account.topTitle')}}</p></el-aside>
                <el-main>
                  <div class="infoPart" style="display:inline-block;">
                    <span class="partLabel">{{$t('account.infoLabels.label1')}}</span>
                    <span class="partVal">{{nameInput}}</span>
                    <el-button icon="el-icon-edit" type="primary" size="mini" @click='shownameInput=true'>{{$t('account.editBtn')}}</el-button>
                    <div class="inputPart" v-show='shownameInput'>
                      <el-input v-model.trim="nameInput"></el-input>
                      <el-button type="danger" size="mini" @click='saveNma()'>{{$t('account.saveBtn')}}</el-button>
                    </div>
                  </div>
                  <div class="infoPart">
                    <span class="partLabel">{{$t('account.infoLabels.label2')}}</span>
                    <canvas class="avatar" width=64 height=64></canvas>
                    
                  </div>
                  <div class="infoPart" style="display:inline-block;">
                    <span class="partLabel">{{$t('account.infoLabels.label3')}}</span>
                    <span class="partVal">{{jobInput}}</span>
                    <el-button icon="el-icon-edit" type="primary" size="mini" @click='showjobInput=true'>{{$t('account.editBtn')}}</el-button>
                    <div class="inputPart" v-show='showjobInput'>
                      <el-input v-model.trim="jobInput"></el-input>
                      <el-button type="danger" size="mini" @click='saveJob'>{{$t('account.saveBtn')}}</el-button>
                    </div>
                  </div>
                  <div class="infoPart">
                    <span class="partLabel">{{$t('account.infoLabels.label4')}}</span>
                    <span>{{baseData.company}}</span>
                    
                  </div>
                </el-main>
              </el-container>
              <!-- 下半部分绑定账号 -->
              <el-container>
                <el-aside width="200px" class="accountLeft"><p>{{$t('account.bottomTitle')}}</p></el-aside>
                <el-main>
                  <div class="infoPart" >
                    <span class="partLabel">{{$t('account.infoLabels.label5')}}</span>
                    <span class="partVal">{{baseData.phone}}</span>
                    <el-button  type="primary" size="mini" @click='showPopup=true,showPopupType=2'>{{$t('account.changeBtn')}}</el-button>
                  </div>
                  <div class="infoPart" >
                    <span class="partLabel">{{$t('account.infoLabels.label6')}}</span>
                    <span class="partVal">{{baseData.email}}</span>
                    <el-button v-if="baseData.email === null || baseData.email === ''" type="primary" size="mini" @click='showPopup=true,showPopupType=3'>{{$t('account.bindBtn')}}</el-button>
                    <el-button v-else type="primary" size="mini" @click='showPopup=true,showPopupType=4'>{{$t('account.unbindBtn')}}</el-button>                      
                  </div>
                  <div class="infoPart" >
                    <span class="partLabel">{{$t('account.infoLabels.label7')}}</span>
                    <span class="partVal">{{baseData.wechatNick}}</span>
                    <el-button v-if="baseData.wechatLoginOpenid === ''|| baseData.wechatLoginOpenid === null" type="primary" size="mini" @click='wxCodeBind()'>{{$t('account.bindBtn')}}</el-button>
                    <el-button v-else type="primary" size="mini" @click='showPopup=true,showPopupType=6'>{{$t('account.unbindBtn')}}</el-button>                      
                  </div>
                  <!-- <div class="infoPart" >
                    <span class="partLabel">{{$t('account.infoLabels.label8')}}</span>
                    <span class="partVal">{{baseData.enterprisewechaNack}}</span>
                    <el-button v-if="baseData.enterprisewechatLoginId === null" type="primary" size="mini" @click='workWXQRcode()'>{{$t('account.bindBtn')}}</el-button>
                    <el-button v-else type="primary" size="mini" @click='showPopup=true,showPopupType=8'>{{$t('account.unbindBtn')}}</el-button>                      
                  </div> -->
                  <div class="infoPart" >
                    <span class="partLabel">{{$t('account.infoLabels.label9')}}</span>
                    <span class="partVal">{{baseData.dingtalkNick}}</span>
                    <el-button v-if="baseData.dingtalkLoginId === '' || baseData.dingtalkLoginId === null" type="primary" size="mini" @click='dingdingQRcode()'>{{$t('account.bindBtn')}}</el-button>
                    <el-button v-else type="primary" size="mini" @click='showPopup=true,showPopupType=10'>{{$t('account.unbindBtn')}}</el-button>                      
                  </div>
                </el-main>
              </el-container>
            </div>       
          </div>
        </el-main>
      </el-scrollbar>
    </el-container>
    <!-- 弹出框 -->
     <div class="popupWrap" v-show="showPopup">
        <!-- 2修改手机号弹框 -->
        <div class="popup" style="padding:10px;" v-show="showPopupType === 2">
          <i class="el-icon-close" @click="closeBind('Phoneform')"></i>
          <div class="innerWrap">
              <p class="popupTitle">{{$t('account.phoneTitle')}}</p>
              <el-form @keyup.enter.native="submitPhoneForm('Phoneform')"  ref="Phoneform" :model="Phoneform" :rules="phoneRules" label-width="0px">
                <el-form-item prop="phone" style="height:40px;margin-bottom:30px">
                  <el-input v-model="Phoneform.phone" :placeholder="$t('account.placehode1')">
                    <el-select style="width:100px;" slot="prepend" v-model="Phoneform.place">
                      <el-option label="+86" value="1"></el-option>
                    </el-select>
                  </el-input>
                </el-form-item>
                <el-form-item prop="code" style="height:40px;margin-bottom:30px">
                  <el-input v-model="Phoneform.code" :placeholder="$t('account.placehode2')">
                    <el-button slot="append" :disabled='getCodeBtn' @click="getCodefun()">{{codeMsg}}</el-button>
                  </el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" class="submitBtn" @click="submitPhoneForm('Phoneform')">{{$t('account.verBtn')}}</el-button>
                </el-form-item>
              </el-form>
          </div>
        </div>
        <!-- 3绑定邮箱 -->
        <div class="popup" style="padding:10px;" v-show="showPopupType === 3">
          <i class="el-icon-close" @click="closeBind('Emailform')"></i>
          <div class="innerWrap">
              <p class="popupTitle">{{$t('account.bindTitle')}}</p>
              <el-form @keyup.enter.native="submitEmailForm('Emailform')"  ref="Emailform" :model="Emailform" :rules="EmailRules" label-width="0px">
                <el-form-item prop="email" style="height:40px;margin-bottom:30px">
                  <el-input v-model="Emailform.email" :placeholder="$t('account.placehode3')"></el-input>
                </el-form-item>
                <el-form-item prop="code" style="height:40px;margin-bottom:30px">
                  <el-input v-model="Emailform.code" :placeholder="$t('account.placehode2')">
                    <el-button slot="append" :disabled='getCodeBtn2' @click="getCodefun2()">{{codeMsg2}}</el-button>
                  </el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" class="submitBtn" @click="submitEmailForm('Emailform')">{{$t('account.verBtn')}}</el-button>
                </el-form-item>
              </el-form>
          </div>
        </div>
        <!-- 4解绑邮箱 -->
        <div class="popup" style="padding:10px;" v-show="showPopupType === 4">
          <i class="el-icon-close" @click="showPopup=false"></i>
          <div class="innerWrap">
              <p class="popupTitle">{{$t('account.unbindTitle')}}</p>
              <strong>{{$t('account.unbindStrong')}}</strong>
              <p class="tips">{{$t('account.unbindtips')}}</p>
              <el-button type="primary" class="ConfirmBtn" @click="unbindEmail()">{{$t('account.cofBtn')}}</el-button>
          </div>
        </div>
        <!-- 5绑定微信 -->
        <div class="popup" style="padding:10px;" v-show="showPopupType === 5">
          <i class="el-icon-close" @click="showPopup=false"></i>
          <div class="innerWrap">
              <p class="popupTitle">{{$t('account.bindTitle2')}}</p>
              <div class="wxCodeWrap" v-loading="wxCodeloading">
                <img :src="wxCodeSrc">
                <p>{{$t('login.wxTips')}}</p>
              </div>
          </div>
        </div>
        <!-- 6解绑微信 -->
        <div class="popup" style="padding:10px;" v-show="showPopupType === 6">
          <i class="el-icon-close" @click="showPopup=false"></i>
          <div class="innerWrap">
              <p class="popupTitle">{{$t('account.unbindTitle2')}}</p>
              <strong>{{$t('account.unbindStrong2')}}</strong>
              <p class="tips">{{$t('account.unbindtips2')}}</p>
              <el-button type="primary" class="ConfirmBtn" @click="unbindWX()">{{$t('account.cofBtn')}}</el-button>
          </div>
        </div>
        <!-- 7绑定企业微信 -->
        <div class="popup" style="padding:10px;" v-show="showPopupType === 7">
          <i class="el-icon-close" @click="showPopup=false"></i>
          <div class="innerWrap">
              <p class="popupTitle">{{$t('account.bindTitle3')}}</p>
              <div class="EnterpriseCodeWrap" id="workWxCodeWrap">
                
              </div>
          </div>
        </div>
        <!-- 8解绑企业微信 -->
        <div class="popup" style="padding:10px;" v-show="showPopupType === 8">
          <i class="el-icon-close" @click="showPopup=false"></i>
          <div class="innerWrap">
              <p class="popupTitle">{{$t('account.unbindTitle3')}}</p>
              <strong>{{$t('account.unbindStrong3')}}</strong>
              <p class="tips">{{$t('account.unbindtips3')}}</p>
              <el-button type="primary" class="ConfirmBtn" @click="workWxUnBind()">{{$t('account.cofBtn')}}</el-button>
          </div>
        </div>
        <!-- 9绑定钉钉 -->
        <div class="popup" style="padding:10px;" v-show="showPopupType === 9">
          <i class="el-icon-close" @click="showPopup=false"></i>
          <div class="innerWrap">
              <p class="popupTitle">{{$t('account.bindTitle4')}}</p>
              <div class="EnterpriseCodeWrap" id="dingdingCodeWrap">
              </div>
          </div>
        </div>
        <!-- 10解绑钉钉 -->
        <div class="popup" style="padding:10px;" v-show="showPopupType === 10">
          <i class="el-icon-close" @click="showPopup=false"></i>
          <div class="innerWrap">
              <p class="popupTitle">{{$t('account.unbindTitle4')}}</p>
              <strong>{{$t('account.unbindStrong4')}}</strong>
              <p class="tips">{{$t('account.unbindtips4')}}</p>
              <el-button type="primary" class="ConfirmBtn" @click="dingdinUnbind()">{{$t('account.cofBtn')}}</el-button>
          </div>
        </div>
     </div>
  </div>
</template>

<script>

import leftNav from "@/components/nav.vue"
export default {
  name: 'account',
  components: {
    leftNav
  },
  data () {
    let _this = this
    var checkPhone = (rule, value, callback) =>{
      let reg = /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/
      if (reg.test(value)){
        _this.getCodeBtn = false
        callback()
      } else if (!value) {
        _this.getCodeBtn = true
        callback(new Error(_this.$t('login.error1')))
      } else {
        _this.getCodeBtn = true
        callback(new Error(_this.$t('login.error3')))
      }
    }
    var checkEmail = (rule, value, callback) =>{
      let reg = /^[0-9a-zA-Z_.-]+[@][0-9a-zA-Z_.-]+([.][a-zA-Z]+){1,2}$/
      if (reg.test(value)){
        _this.getCodeBtn2 = false
        callback()
      } else if (!value) {
        _this.getCodeBtn2 = true
        callback(new Error(_this.$t('account.error3')))
      } else {
        _this.getCodeBtn2 = true
        callback(new Error(_this.$t('account.error4')))
      }
    }
    return {
      // 基本信息
      baseData:{},
      // 修改名称
      nameInput: '',
      shownameInput: false,
      // 修改工作
      jobInput: '',
      showjobInput: false,
      // 显示弹出框
      showPopup:false,
      showPopupType:1,
      // 修改手机表单验证
      Phoneform:{
        phone: '',
        place: '1',
        code: ''
      },
      phoneRules:{
        phone: [
          { validator: checkPhone, trigger: 'change' }
        ],
        code: [
          { required: true, message: this.$t('account.error2'), trigger: 'change' },
        ]
      },
       // 手机验证码倒计时时间
      codeTime: 60,
      codeMsg: this.$t('account.getBtn'),
      getCodeBtn: true,
      // 绑定邮箱
      Emailform:{
        email: '',
        code: ''
      },
      EmailRules:{
        email: [
          { validator: checkEmail, trigger: 'change' }
        ],
        code: [
          { required: true, message: this.$t('account.error2'), trigger: 'change' },
        ]
      },
      // 邮箱验证码倒计时
      codeTime2: 60,
      codeMsg2: this.$t('account.getBtn'),
      getCodeBtn2: true,
      // loading
      fullscreenLoading: false,
      wxCodeloading:false,
      // 微信二维码推按地址
      wxCodeSrc: '',
      // 扫码成功后获取到的数据
      parameters: {},
      // 倒计时
      countDown: '',
      countDown2: '',
      // 工厂名称
      fName: ''
    }
  },
  computed: {
    islangChange () {
      return this.$store.state.lang
    }
  },
  watch: {
    islangChange (curval, oldval) {
      if (curval != oldval) {
        this.$parent.reload()
      }
    }
  },
  mounted() {
    if (this.$store.state.reloadState === false) {
      this.$store.state.reloadState = true
      this.$parent.reload()
    }else{
      var address = window.location.host.split(".")
      this.fName = address[0]
      this.getParameter(window.location.search)
      this.touxaing()
    }
  },
  destroyed () {
    if (this.websock!==''){
      this.websock.close()
    }
  },
  methods: {
    // 获取url参数
    getParameter(url){
      this.parameters = {}
      let _this = this
      if (url !== '') {
        new Promise(function(resolve) {
          let parameterArr = url.substr(1).split("&")
          for(let item of parameterArr){
            let resArr = item.split("=")
            _this.parameters[resArr[0]] = resArr[1]
          }
          resolve();
        }).then(function() {
          if (_this.parameters.state === 'workWx'){
            _this.workWxBind()
          }else if (_this.parameters.state === 'dingding'){
            _this.dingdinBind()
          }
        })
      } else {
        this.getBaseData()
      }
      
    },
    // 获取基本信息
    getBaseData(){
      let _this =this 
      this.fullscreenLoading = true
      this.axios({
        method: 'post',
        url: '/url/account/basic',
        params:{
          language: _this.$store.state.lang
        }
      }).then(function(res){
        if(res.data.success === true){
          if(res.data.msg.profile === null){
            res.data.msg.profile = 'data:image/png;base64,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'
          }
          console.log(res.data.msg)
          _this.baseData = res.data.msg
          _this.nameInput = res.data.msg.login
          _this.jobInput = res.data.msg.jobName
          
        }
        _this.fullscreenLoading = false
      })
    },
    saveNma(){
      if (this.nameInput === ''){
        this.$message.error(this.$t('account.error'));
      }else{
        this.changeData(this.nameInput,'')
        this.shownameInput = false
      }
    },
    saveJob(){
      if (this.jobInput === ''){
        this.$message.error(this.$t('account.error'));
      }else{
        this.changeData('',this.jobInput)
        this.showjobInput = false
      }
    },
    // 修改名称和职位
    changeData(name,job){
      let _this =this
      let ajaxData ={}
      if(name === ''){
        ajaxData={
          jobName: job,
          language: _this.$store.state.lang
        }
      }else if(job===''){
        ajaxData={
          login: name,
          language: _this.$store.state.lang
        }
      }
      this.axios({
        method: 'post',
        url: '/url/account/update',
        params:ajaxData
      }).then(function(res){
        if(res.data.success === 'false'){
          this.$message.error(res.data.msg);
        }
      })
    },

    //  修改手机号提交
    submitPhoneForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let _this = this
          this.fullscreenLoading = true
          this.axios({
            method: 'post',
            url: '/url/account/phoneInTie',
            params:{
              phone: _this.Phoneform.phone,
              code: _this.Phoneform.code,
              language: _this.$store.state.lang
            }
          }).then(function(res){
            if(res.data.success === "true"){
              _this.closeBind('Phoneform')
              _this.getBaseData()
            }else{
              _this.$alert(res.data.msg,"", {
                confirmButtonText: _this.$t('account.cofBtn')
              });
              _this.fullscreenLoading = false
            }
          })

        } else {
          return false
        }
      })
    },
    // 短信获取验证倒计时
    codeTiming(){
      if (this.codeTime === 0) {
        this.codeMsg = this.$t('account.getBtn')
        this.codeTime = 60
        this.getCodeBtn = false
      } else {
        this.getCodeBtn = true
        this.codeTime--
        this.codeMsg = '(' + this.codeTime + 's)'
        this.countDown = setTimeout(this.codeTiming, 1000)
      }
    },
    // 获取验证码
    getCodefun(){
      let _this = this
      this.getCodeBtn = true
      this.axios({
        method: 'post',
        url: '/url/account/phoneSendCode',
        params:{
          phone: _this.Phoneform.phone,
          language: _this.$store.state.lang
        }
      }).then(function(res){
        if(res.data.success === true){
          _this.codeTiming()
        }else{
          _this.$alert(res.data.msg,"", {
            confirmButtonText: _this.$t('account.cofBtn')
          });
          _this.getCodeBtn = false
        }
      })
    },
    // 邮箱表单验证
    submitEmailForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let _this = this
          this.fullscreenLoading = true
          this.axios({
            method: 'post',
            url: '/url/account/mailBinding',
            params:{
              email: _this.Emailform.email,
              code: _this.Emailform.code,
              language: _this.$store.state.lang
            }
          }).then(function(res){
            if(res.data.success === 'true'){
              _this.closeBind('Emailform')
              _this.$message({
                message: _this.$t('account.bindSuc'),
                type: 'success'
              });
              _this.getBaseData()
            }else{
              _this.$alert(res.data.msg,"", {
                confirmButtonText: _this.$t('account.cofBtn')
              });
              _this.fullscreenLoading = false
            }
          })
        } else {
          return false
        }
      })
    },
    // 邮箱获取验证倒计时
    codeTiming2(){
      if (this.codeTime2 === 0) {
        this.codeMsg2 = this.$t('account.getBtn')
        this.codeTime2 = 60
        this.getCodeBtn2 = false
      } else {
        this.getCodeBtn2 = true
        this.codeTime2--
        this.codeMsg2 = '(' + this.codeTime2 + 's)'
        this.countDown2=setTimeout(this.codeTiming2, 1000)
      }
    },
    // 邮箱获取验证码
    getCodefun2(){
      this.getCodeBtn2 = true
      let _this =this
      this.axios({
        method: 'post',
        url: '/url/account/mailCode',
        params:{
          email: _this.Emailform.email,
          language: _this.$store.state.lang
        }
      }).then(function(res){
        if (res.data.success === true){
          _this.codeTiming2()
        }else {
          _this.$alert(res.data.msg,"", {
            confirmButtonText: _this.$t('account.cofBtn')
          });
          _this.getCodeBtn2 = false
        }
      })
    },
    // 关闭并重置表单
    closeBind(formName){
      this.showPopup = false
      this.$refs[formName].resetFields()
      this.clearTiming()
    },
    // 解绑邮箱
    unbindEmail(){
      let _this = this
      this.fullscreenLoading = true
      this.axios({
        method: 'post',
        url: '/url/account/unbundle',
        params:{
          email: _this.baseData.email,
          language: _this.$store.state.lang
        }
      }).then(function(res){
        if(res.data.success === 'true'){
          _this.showPopup = false
          _this.getBaseData()
        }else {
          _this.$alert(res.data.msg,"", {
            confirmButtonText: _this.$t('account.cofBtn')
          });
          _this.fullscreenLoading = false
        }
      })
    },
    // 微信扫码绑定(未测试)
    wxCodeBind(){
      var nameId = 100
      if (this.fName === 'jiande') {
        nameId = 100
      }else if (this.fName === 'guilun'){
        nameId = 101
      }else if (this.fName === 'xinjiang'){
        nameId = 102
      }
      this.showPopup = true
      this.showPopupType = 5
      this.wxCodeloading=true
      // 生成唯一数字 （时间戳+ip+随机数）
      let num1 = this.randomNum();
      let num2 = this.randomNum();
      // let cityIp = window.returnCitySN["cip"].split(".").join("")
      // let ownID = new Date().getTime()/2 + (Number(num1) + Number(num2) + Number(cityIp))/2
      let ownID = new Date().getTime()/2 + (Number(num1) + Number(num2))/2
      let randomID = nameId + String(parseInt(ownID)).substring(String(parseInt(ownID)).length-6)
      this.getQRcode(randomID)
    },
    // 获取随机数
    randomNum(){
      var Num=""; 
      for(var i=0;i<6;i++) { 
        Num+=Math.floor(Math.random()*10); 
      }
      return Num
    },
    // 获取公众号二维码
    getQRcode(id){
      let _this = this
      this.axios({
        method: 'post',
        url: '/url/getQrcode',
        params:{
          sceneId: id
        }
      }).then(function(res){
        _this.wxCodeSrc = res.data.path
        _this.wxCodeloading=false
      }).then(function(){
        _this.initWebSocket(id)
      })
    },
    // 获取成功后立即建立websocket连接
    initWebSocket(id){
      let _this = this
      _this.websock = new WebSocket("ws://" + _this.$store.state.websocketws + "wechat/websocket/"+id)
      // 接收服务器发来的消息
      _this.websock.onmessage = function (e) {
        let info = JSON.parse(e.data)
        if (info.success === true) {
          _this.wxQRCodeBind(info.openid)
        }
      }
      // 连接建立失败重连
      _this.websock.onerror = function () {
        _this.websock = new WebSocket("ws://" + _this.$store.state.websocketws + "wechat/websocket/"+id)
      }
      // 关闭
      _this.websock.onclose = function () {
        _this.websock = null
      }
    },
    // 微信二维码绑定
    wxQRCodeBind(openid){
      this.fullscreenLoading = true
      let _this = this
      this.axios({
        method: 'post',
        url: '/url/wechatBinding',
        params:{
          openid:openid,
          language: Number(localStorage.getItem('lang'))
        }
      }).then(function(res){
        if (res.data.success === 'true') {
          _this.showPopup = false
          _this.getBaseData()
        }else{
          _this.fullscreenLoading = false
          _this.$alert(res.data.msg,"", {
            confirmButtonText: _this.$t('account.cofBtn')
          });
        }
      })
    },
    // 解绑微信
    unbindWX(){
      let _this = this
       this.fullscreenLoading = true
      this.axios({
        method: 'post',
        url: '/url/account/unbundle',
        params:{
          wechatLoginOpenid: _this.baseData.wechatLoginOpenid,
          language: _this.$store.state.lang
        }
      }).then(function(res){
        if(res.data.success === 'true'){
          _this.showPopup = false
          _this.getBaseData()
        }else {
          _this.$alert(res.data.msg,"", {
            confirmButtonText: _this.$t('account.cofBtn')
          });
          _this.showPopup = false
          _this.fullscreenLoading = false
        }
      })
    },
    
    // 企业微信扫码
    workWXQRcode(){
      this.showPopup = true
      this.showPopupType = 7
      var agentId,redirectUri
      if (this.fName === 'jiande') {
        agentId = '1000013'
        redirectUri = 'http://jiande.tst-cloud.com/account'
      }else if (this.fName === 'guilun'){
        agentId = '1000014'
        redirectUri = 'http://guilun.tst-cloud.com/account'
      }else if (this.fName === 'xinjiang'){
        agentId = '1000016'
        redirectUri = 'http://xinjiang.tst-cloud.com/account'
      }
      window.WwLogin({
        "id" : "workWxCodeWrap",
        "appid" : "ww0cbdc98c26639a6e",
        "agentid" : agentId,
        "redirect_uri" :redirectUri,
        "state" : "workWx",
        "href": ''
      })
    },
    // 绑定企业微信
    workWxBind(){
      let _this = this
      this.axios({
        method: 'post',
        url: '/url/enterpriseWechatBinding',
        params:{
          code: _this.parameters.code,
          language: _this.$store.state.lang
        }
      }).then(function(res){
        if (res.data.success === "true") {
          _this.getBaseData()
          _this.$router.push({path: '/account', name: 'account'})
        }else {
          _this.$alert(res.data.msg,"", {
            confirmButtonText: _this.$t('account.cofBtn'),
            callback: () => {
              _this.getBaseData()
              _this.$router.push({path: '/account', name: 'account'})
            }
          });
          
        }
      })
    },
    // 解绑企业微信
    workWxUnBind(){
      let _this = this
      this.fullscreenLoading = true
      this.axios({
        method: 'post',
        url: '/url/account/unbundle',
        params:{
          enterprisewechatLoginId: _this.baseData.enterprisewechatLoginId,
          language: _this.$store.state.lang
        }
      }).then(function(res){
        if(res.data.success === 'true'){
          _this.showPopup = false
          _this.getBaseData()
        }else {
          _this.$alert(res.data.msg,"", {
            confirmButtonText: _this.$t('account.cofBtn')
          });
          _this.showPopup = false
          _this.fullscreenLoading = false
        }
      })
    },
    // 钉钉扫码
    dingdingQRcode(){
      this.showPopup=true
      this.showPopupType=9
      let appId = 'dingfzw4mrtgnf5qknk5'
      let redirectUri = 'http%3a%2f%2fwww.tst-cloud.com%2faccount'
      // let redirectUri = 'http%3a%2f%2fadvance.tst-cloud.com%2faccount'
      window.DDLogin({
        id:"dingdingCodeWrap",
        goto: "https%3a%2f%2foapi.dingtalk.com%2fconnect%2fqrconnect%3fappid%3d"+appId+"%26response_type%3dcode%26scope%3dsnsapi_login%26state%3dSTATE%26redirect_uri%3d"+redirectUri, //请参考注释里的方式
        style: "border:none;background-color:#FFFFFF;width:330px;"
      })
      let handleMessage = function (event) {
        let origin = event.origin;
        if( origin == "https://login.dingtalk.com" ) { //判断是否来自ddLogin扫码事件。
          let loginTmpCode = event.data; //拿到loginTmpCode后就可以在这里构造跳转链接进行跳转了
          let url = `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${appId}&response_type=code&scope=snsapi_login&state=dingding&redirect_uri=${redirectUri}&loginTmpCode=${loginTmpCode}`
          window.location.href = url
        }
      };
      if (typeof window.addEventListener != 'undefined') {
          window.addEventListener('message', handleMessage, false);
      } else if (typeof window.attachEvent != 'undefined') {
          window.attachEvent('onmessage', handleMessage);
      }
    },
    // 绑定钉钉
    dingdinBind(){
      this.fullscreenLoading = true
      let _this = this
      this.axios({
        method: 'post',
        url: '/url/dingtalkBinding',
        params:{
          code: _this.parameters.code,
          state: _this.parameters.state,
          language: _this.$store.state.lang
        }
      }).then(function(res){
        if (res.data.success === "true") {
          _this.getBaseData()
          _this.$router.push({path: '/account', name: 'account'})
        }else {
          _this.$alert(res.data.msg,"", {
            confirmButtonText: _this.$t('account.cofBtn'),
            callback: () => {
              _this.getBaseData()
              _this.$router.push({path: '/account', name: 'account'})
            }
          });
        }
      })
    },
    // 解绑钉钉
    dingdinUnbind(){
      let _this = this
      this.fullscreenLoading = true
      this.axios({
        method: 'post',
        url: '/url/account/unbundle',
        params:{
          dingtalkLoginId: _this.baseData.dingtalkLoginId,
          language: _this.$store.state.lang
        }
      }).then(function(res){
        if(res.data.success === 'true'){
          _this.showPopup = false
          _this.getBaseData()
        }else {
          _this.$alert(res.data.msg,"", {
            confirmButtonText: _this.$t('account.cofBtn')
          });
          _this.showPopup = false
          _this.fullscreenLoading = false
        }
      })
    },
    // 随机头像
    touxaing () {
      let canvasDiv = document.querySelector('.avatar'),
      usename =localStorage.getItem('userName')
      var strangeHash = function strangeHash(str) {
          var hash = 0;
          if ( str.length === 0) {
              return hash;
          }
    
          for (var i = 0, len = str.length; i < len; i++) {
              var chr = str.charCodeAt(i);
              hash = (hash << 5) - hash + chr;
              hash |= 0;
          }
    
          return (new Array(9).join('1') + Math.abs(hash)).slice(-8).replace(/0/g, '1'); // Generate string with 8 chars without '0'
      };
    
      draw(canvasDiv);
      function draw(c) {
          var ctx = c.getContext('2d'),
              h = strangeHash(usename);
          ctx.translate(32, 32);  
          ctx.rotate(Math.PI / 4);
          
          for (var j = 0; j < 8; j++) {
              // Colors (Red, Green, Blue, Alpha) is here.
              var r = h[0] * 100 % 255,
                  // This formula doesn't make sense
                  g = h[j] * 100 % 255,
                  // And this too...
                  b = h[8 - j] * 100 % 255,
                  // Too many strange ideas in this generator :)
                  a = h[j] / 20;
    
              ctx.fillStyle = 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
    
              // Coordinates of rectangle. Another strange thing. But result looks fine...
              var c1 = h[j] * h[j] % 16,
                  c2 = h[j] * h[7] % 16,
                  c3 = h[j] * h[0] % 32,
                  c4 = h[j] * h[0] % 32;
    
              // Some "normalization"
              if (c1 + c2 < 32) {
                  c1 *= -2;
                  c2 *= -2;
                  c3 *= 2;
                  c4 *= 2;
              }
    
              // Some experiments here......
              var s = h[7] % 2 + 2;
    
              for (var k = 0; k < 2 * s; k++) {
                  ctx.fillRect(c1, c2, c3, c4);
                  ctx.rotate(Math.PI / s);
              }
          }
      }
    },
    // 清除倒计时
    clearTiming(){
      this.codeMsg = this.$t('account.getBtn')
      this.codeTime = 60
      this.getCodeBtn = true
      this.codeMsg2 = this.$t('account.getBtn')
      this.codeTime2 = 60
      this.getCodeBtn2 = true
      clearTimeout(this.countDown)
      clearTimeout(this.countDown2)
    }

  }
  
}
</script>
<style scoped>
.ReloadingStatistics{
  min-width: 1365px!important;
}
.mainWrao{
  height: 100%;
  min-width: 100%;
  background-color: #f6f9fc;
  box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  border-radius: 4px;
  padding-bottom: 30px;
}
.recordTitle{
  padding: 20px 25px;
  background-color: #fff;
  border-bottom: 1px solid #e5e5e5;
  border-radius: 4px 4px 0 0;
  line-height: 35px;
}
.recordTitle h1{
  font-size: 20px;
  color: #525f7f;
  margin-bottom: 5px;
  display: inline-block;
}
.tableWrap{
  box-sizing: border-box;
  margin: 20px 15px;
}
.accountLeft p{
  font-size: 16px;
  margin-left: 10px;
  font-weight: bold;
  padding-top: 20px;
}
.infoPart{
  position: relative;
  margin-bottom: 15px;
}
.infoPart span{
  display: inline-block;
  font-size: 14px;
  color: rgba(56, 56, 56, 1);
}
.infoPart .partLabel{
  width: 140px;
}
.infoPart .partVal{
  min-width: 150px;
  max-width: 540px;
}
.infoPart img{
  width: 50px;
  height: 50px;
  cursor: pointer;
  vertical-align: middle;
}
.infoPart button{
  margin-left: 10px;
}
.infoPart .inputPart{
  width: calc(100% - 140px);
  background-color: #f6f9fc;
  position: absolute;
  top: 0;
  left: 140px;
}
.infoPart .inputPart button{
  width: 60px;
}
.infoPart .inputPart .el-input{
  width: calc(100% - 70px);
  height: 28px;
  line-height: 28px;
}
.popupWrap{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5)
}
.popupWrap .popup{
  min-width:440px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  background-color: #fff;
}
.el-icon-close{
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 30px;
  color: #c0c0c0;
  cursor: pointer;
}
.popup img{
  width: 450px;
  display: block;
  margin: 30px auto;
}
.innerWrap{
  width:365px;
  margin:30px auto;
}
.innerWrap .popupTitle{
  color:#6772e5;
  border-bottom:1px solid #6772e5;
  font-size:17px;
  padding:15px 0;
  text-align:center;
  margin-bottom:50px;
}
.innerWrap .submitBtn{
  width:100%;
  margin:30px 0;
}
.innerWrap strong{
  font-weight: bold;
  font-size: 16px;
}
.innerWrap .tips{
  font-size: 15px;
  margin: 25px 0 90px
}
.innerWrap .ConfirmBtn{
  width: 100%;
}
.wxCodeWrap{
  height: 300px;
  text-align: center;
}
.wxCodeWrap img{
  width: 250px;
  height: 250px;
  display: inline-block;
  margin: 0;
}
.wxCodeWrap p{
  font-size:14px;
  color:rgba(128, 128, 128, 1);
}
.upFile{
  display: inline-block;
  margin-left: 99px;
}
.EnterpriseCodeWrap{
  text-align: center;
}
.avatar{
  border-radius: 50%;
  vertical-align: middle;
  box-shadow: 0 3px 3px 0 rgba(0, 0, 0, .15)
}
</style>

